import axios from 'axios';
import Globals from '../Globals';
import LoggingService from './LoggingService';
import { getLogModel } from '../Functions';

class LoginService {
    base_url = Globals.BFF_PATH.BASE_URL + Globals.BFF_PATH.LOGIN.BASE_PATH;

    doLogin = async body => {
        const config = {
            headers: {
                // 'Authorization': _token,
                ErrorCode: Globals.ERROR_CODE,
            },
        };

        const data = {
            headers: {
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(body),
        };

        return axios
            .post(this.base_url + Globals.BFF_PATH.LOGIN.DO, data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    refreshToken = async token => {
        const config = {
            headers: {
                ErrorCode: Globals.ERROR_CODE,
            },
        };
        const data = {
            headers: {
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(token),
        };

        return axios
            .post(
                this.base_url + Globals.BFF_PATH.LOGIN.REFRESH_TOKEN,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

    refresh = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
        };

        return axios
            .post(this.base_url + Globals.BFF_PATH.LOGIN.REFRESH, data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    forgot = async options => {
        const config = {
            headers: {
                // 'Authorization': `${token}`,
                UrlLocation: options.url,
                ErrorCode: Globals.ERROR_CODE,
            },
        };

        const data = {
            headers: {
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(options),
            // body: options.data
        };
        // const data = options.data;
        return axios
            .post(
                this.base_url + Globals.BFF_PATH.LOGIN.RESET_PASSWORD,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data.body;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    serverTime = async () => {
        const config = {
            headers: {},
        };
        const data = {
            headers: {
                ErrorCode: Globals.ERROR_CODE,
            },
        };
        return axios
            .post(
                this.base_url + Globals.BFF_PATH.LOGIN.SERVER_TIME,
                data,
                config
            )
            .then(response => {
                return response.data;
            })
            .catch(function () {
                return;
            });
    };
}

export default LoginService;
